import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.surface.default};
  padding: 3.2rem;
`;
export const CardContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  padding: 3.6rem;
  margin-bottom: 3rem;
`;
export const CardWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.surface.default};

  padding: 2rem;
`;
